// Centralized error message handler
// Returns a user-friendly error message for display

export const getErrorMessage = (error) => {
  // Log the actual error for debugging (you can check browser console)
  const errorMessage = error?.response?.data?.error || error?.message || '';
  console.error('[PickNPray Error]', errorMessage || error);

  // Check for authentication errors (invalid credentials)
  const lowerError = errorMessage.toLowerCase();
  if (lowerError.includes('invalid') ||
      lowerError.includes('credentials') ||
      lowerError.includes('password') ||
      lowerError.includes('email') ||
      lowerError.includes('user not found') ||
      lowerError.includes('authentication')) {
    return 'Invalid email or password';
  }

  // Return generic support message for other errors
  return 'Error: Contact kyle@picknpray.com for support';
};

export default getErrorMessage;
